'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * MarketoForm
 *
 * React component for embedding a Marketo Forms 2.0 form
 *
 * Marketo's API docs: http://developers.marketo.com/documentation/websites/forms-2-0/
 *
 * Normally, you embed a Marketo form like this:
 *
 *     <script src="//app-ab07.marketo.com/js/forms2/js/forms2.min.js"></script>
 *     <form id="mktoForm_1115"></form>
 *     <script>MktoForms2.loadForm("//app-ab07.marketo.com", "925-YQB-645", 1115);</script>
 *
 * This React component wraps that functionality for you. All you need to provide are the arguments to
 *
 *     MktoForms2.loadForm(baseUrl, munchkinId, formId, [onLoad callback])
 *
 * (as seen in the example above) as React props.
 *
 * TODO: Show some visual indication that the form is loading before Marketo injects it?
 * TODO: (That could be accomplished by defining a callback function here, which removes a loading indicator after load)
 * TODO: Show some fallback message when Marketo is blocked or fails to inject the form?
 */
var MarketoForm = _react2['default'].createClass({
  displayName: 'MarketoForm',


  //mixins: [watchAppNotifierMixin],

  propTypes: {
    'baseUrl': _react2['default'].PropTypes.string, // All of our forms use the same base URL so far, so this is optional
    'munchkinId': _react2['default'].PropTypes.string, // All of our forms use the same munchkinId so far, so this is optional
    'formId': _react2['default'].PropTypes.number.isRequired, // Numeric, typically 4-digit form ID
    'onLoad': _react2['default'].PropTypes.func, // Optional callback function for Marketo's loadForm
    'className': _react2['default'].PropTypes.string // Optional class name(s) for the form element
  },

  getInitialState: function getInitialState() {
    return {};
  },

  getDefaultProps: function getDefaultProps() {
    return {
      'baseUrl': "//app-ab07.marketo.com",
      'munchkinId': "925-YQB-645",
      'onLoad': null,
      'className': ''
    };
  },

  componentDidMount: function componentDidMount() {
    // Inject the Marketo forms script
    var script = document.createElement('script');
    script.src = this.props.baseUrl + '/js/forms2/js/forms2.min.js';
    script.charset = 'utf-8';
    script.async = true;
    document.body.appendChild(script);

    // Then call loadForm on our div
    MktoForms2.loadForm(this.props.baseUrl, this.props.munchkinId, this.props.formId, this.props.onLoad);
  },

  shouldComponentUpdate: function shouldComponentUpdate() {
    // We never want to re-render, since that would override the content injected by Marketo's script
    return false;
  },

  render: function render() {
    var formId = "mktoForm_" + this.props.formId;
    var classNames = "rx-marketo-form " + this.props.className;
    return _jsx('div', {
      className: 'm-marketo-form'
    }, void 0, _jsx('form', {
      id: formId,
      className: classNames
    }, void 0));
  }
});

module.exports = MarketoForm;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/marketo-form/index.jsx
 ** module id = 744
 ** module chunks = 0
 **/